import styled from "styled-components";
import { SubmitButton } from "./BaseButton";
import { SIDEMENU, MAINMENU } from "Consts/menuTypes";
import React from "react";
import { MenuButtonIcons } from "Components/Menu";

export const MenuButtonStyle = styled(SubmitButton)`
	& {
		position: relative;
		border: ${({ Depth, MenuType, theme }) =>
			Depth == 1 && MenuType == SIDEMENU
				? `2px solid ${theme.colors.white}`
				: `2px solid ${theme.colors.primary}`};
		background-color: ${({ IsExpanded, MenuType, theme }) =>
			IsExpanded && MenuType == MAINMENU ? theme.colors.bg1 : "transparent"};

		border-radius: 50%;
		color: #0e3c7c;
		font-size: 16px;
		margin: 5px 10px;
		display: flex;
		align-items: center;
		justify-content: center;
		width: 30px;
		height: 30px;
		transition: 0.2s ease;
		svg {
			transition: 0.2s ease;

			stroke: ${({ MenuType, Depth, theme }) =>
				MenuType == SIDEMENU && Depth == 1 ? theme.colors.white : theme.colors.primary};
		}
		:hover {
			transition: 0.2s ease;
			background-color: ${({ Depth, MenuType, theme }) =>
				Depth == 1
					? MenuType == SIDEMENU && "white"
					: MenuType == SIDEMENU && theme.colors.primary};

			svg {
				stroke: ${({ MenuType, Depth, theme }) =>
					MenuType == SIDEMENU && Depth == 1
						? theme.colors.primary
						: theme.colors.white};
			}
		}
	}
`;

export const MenuButton = ({ IsExpanded, Depth, MenuType, ShouldAnimate, Width, onClick }) => {
	return (
		<MenuButtonStyle
			className={'toggle'}
			tabIndex="0"
			onClick={onClick}
			IsExpanded={IsExpanded}
			width={Width}
			Depth={Depth}
			MenuType={MenuType}
			type="button"
		>
			<MenuButtonIcons
				ShouldAnimate={ShouldAnimate}
				Depth={Depth}
				IsExpanded={IsExpanded}
			/>
		</MenuButtonStyle>
	);
};
